<template>
    <div>
        <ds-list-item
            v-for="item in listItems"
            :key="item.id"
            #title
            clickable
            target="_blank"
            @click="handleClick(item)"
        >
            <ds-avatar :name="item.id.toString()" /> {{ item.label }}
        </ds-list-item>
    </div>
</template>


<script>

import amplitude from '@/components/util/analytics/amplitude';

const CLASSIC_LINKS = [
    {
        id: 1,
        link: 'https://www.youtube.com/watch?v=oQK8hnoNKkQ&t=56s',
        label: 'Review email engagement essentials',
    },
    {
        id: 2,
        link: 'https://help.infusionsoft.com/help/unengaged-contacts',
        label: 'Remove unengaged contacts from Marketing',
    },
    {
        id: 3,
        link: 'https://help.infusionsoft.com/help/dkim#set-up-dkim',
        label: 'Ensure DKIM is set',
    },
    {
        id: 4,
        link: 'https://help.infusionsoft.com/help/how-to-avoid-content-filters',
        label: 'Review your email content',
    },
    {
        id: 5,
        link: 'https://help.infusionsoft.com/help/find-and-tag-unengaged-contacts',
        label: 'Start re-engagement campaign (for low engagement)',
    },
    {
        id: 6,
        link: '/app/miscSetting/itemWrapper?systemId=nav.marketing&settingModuleName=Marketing&settingTabName=email.addressstatus.limits.title',
        label: 'Set List Automation',
    },
];

const UPDATED_CLASSIC_LINKS = [
    {
        id: 1,
        link: 'https://help.infusionsoft.com/help/dkim#set-up-dkim',
        label: 'Ensure DKIM is set',
    },
    {
        id: 2,
        link: 'https://help.infusionsoft.com/help/engagement-essentials',
        label: 'Review email engagement essentials',
    },
    {
        id: 3,
        link: 'https://help.infusionsoft.com/help/find-and-tag-unengaged-contacts',
        label: 'Tag unengaged contacts',
    },
    {
        id: 4,
        link: 'https://help.infusionsoft.com/help/how-to-avoid-content-filters',
        label: 'Review your email content',
    },
    {
        id: 5,
        link: 'https://help.infusionsoft.com/help/send-re-engagement-email-to-unengaged-contacts',
        label: 'Start re-engagement campaign (for low engagement)',
    },
    {
        id: 6,
        link: 'https://help.infusionsoft.com/help/automated-list-management',
        label: 'Set List Automation',
    }
];

const KEAP_LINKS = [
    {
        id: 1,
        link: 'https://www.youtube.com/watch?v=oQK8hnoNKkQ&t=56s',
        label: 'Review email engagement essentials',
    },
    {
        id: 2,
        link: 'https://help.keap.com/help/email-confirmation-sequence',
        label: 'Remove unengaged contacts from Marketing',
    },
    {
        id: 3,
        link: 'https://help.keap.com/help/dmarc',
        label: 'Ensure DKIM is set',
    },
    {
        id: 4,
        link: 'https://help.keap.com/help/how-to-avoid-content-filters',
        label: 'Review your email content',
    },
    {
        id: 5,
        link: 'https://help.keap.com/help/play-blueprint-21000-reengagement-offer',
        label: 'Start re-engagement campaign (for low engagement)',
    },
];

const UPDATED_KEAP_LINKS = [
    {
        id: 1,
        link: 'https://help.keap.com/help/dmarc',
        label: 'Ensure DKIM is set',
    },
    {
        id: 2,
        link: 'https://help.infusionsoft.com/help/engagement-essentials',
        label: 'Review email engagement essentials',
    },
    {
        id: 3,
        link: 'https://help.infusionsoft.com/help/find-and-tag-unengaged-contacts',
        label: 'Tag unengaged contacts',
    },
    {
        id: 4,
        link: 'https://help.keap.com/help/how-to-avoid-content-filters',
        label: 'Review your email content',
    },
    {
        id: 5,
        link: 'https://help.infusionsoft.com/help/send-re-engagement-email-to-unengaged-contacts',
        label: 'Start re-engagement campaign (for low engagement)',
    },
];

export default {
    props: {
        isUpdateHelpArticleLinksEnabled: {
            type: Boolean,
            default: false,
        },
        isUnengagedEmailStatusProcessingEnabled: Boolean,
        appEdition: String,
    },
    computed: {
        listItems() {
            const isClassic = this.appEdition === 'Keap Max Classic Edition';
            const isUpdated = this.isUpdateHelpArticleLinksEnabled;

            if (isClassic) {
                return isUpdated ? UPDATED_CLASSIC_LINKS : CLASSIC_LINKS;
            }

            return isUpdated ? UPDATED_KEAP_LINKS : KEAP_LINKS;
        },
    },

    methods: {
        handleClick(object) {
            window.open(object.link, '_blank');

            this.emitAmplitudeEvent(object.label);
        },

        emitAmplitudeEvent(event) {
            amplitude.infusionsoft.track('Email Analytics - CTA / Help', {
                'Event Source': 'Email Analytics Engagement Page',
                Destination: event,
            });
        },
    },


};

</script>

<style lang="scss" scoped>

#leadingSlot {
    padding: 0;
}

.list-item-description {
    font-size: $font-size-md;
    padding-right: $spacing-200;
}

.row {
    display: flex;
}

.column-left {
    flex: 50%;
    float: left;
}

.column-right {
    flex: 50%;
    text-align: right;
}

</style>
